/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClrIconModule } from "../../icon/icon.module";
import { ClrCommonPopoverModule } from "../../popover/common/popover.module";
import { BUTTON_GROUP_DIRECTIVES } from "./index";
var ClrButtonGroupModule = (function () {
    function ClrButtonGroupModule() {
    }
    return ClrButtonGroupModule;
}());
export { ClrButtonGroupModule };
ClrButtonGroupModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ClrIconModule,
                    ClrCommonPopoverModule
                ],
                declarations: [
                    BUTTON_GROUP_DIRECTIVES
                ],
                exports: [
                    BUTTON_GROUP_DIRECTIVES
                ]
            },] },
];
/** @nocollapse */
ClrButtonGroupModule.ctorParameters = function () { return []; };
//# sourceMappingURL=button-group.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/button/button-group/button-group.module.js
// module id = 140
// module chunks = 4